<div class="shared-container">
  <div class="modal-container">
    <div class="modal-header">
      <div class="d-flex box-header">
        <h2 class="modal-title">CRIAR TAREFA</h2>
        <button class="btn-close" (click)="fechar.emit()">x</button>
      </div>
      <p class="modal-subtitle">Preencha os campos para criar uma nova tarefa.</p>
    </div>

    <div class="modal-body">
      <div *ngIf="empresaId" class="empresa-selecionada">
        <strong>Empresa:</strong> {{ empresaNome }}
      </div>

      <label>CONTATOS *</label>
      <div class="contatos-selecionados">
        <span *ngFor="let c of contatos" class="chip-contato">{{ c.name }}</span>
        <span *ngIf="!contatos.length" class="sem-contato">Nenhum contato selecionado</span>
      </div>
      <p class="contatos-info" *ngIf="contatos.length > 1">
        Será criada uma tarefa para cada contato selecionado.
      </p>

      <label for="responsavel">RESPONSÁVEL *</label>
      <select
        id="responsavel"
        [(ngModel)]="responsibleID"
        class="form-control"
        [ngClass]="{ 'is-invalid': erro && !responsibleID }"
      >
        <option value="" disabled>Selecione um responsável</option>
        <option *ngFor="let r of responsaveis" [value]="r.id">{{ r.name }}</option>
      </select>

      <label for="tarefa">TIPO DE TAREFA *</label>
      <select
        id="tarefa"
        [(ngModel)]="actionID"
        class="form-control"
        [ngClass]="{ 'is-invalid': erro && !actionID }"
      >
        <option value="" disabled>Escolher Tarefa</option>
        <option *ngFor="let a of acoes" [value]="a.actionId">{{ a.description }}</option>
      </select>

      <div class="date-time">
        <div>
          <label for="data">DATA *</label>
          <input
            id="data"
            type="date"
            [(ngModel)]="data"
            class="form-control"
            [ngClass]="{ 'is-invalid': erro && !data }"
          />
        </div>
        <div>
          <label for="hora">HORA *</label>
          <input
            id="hora"
            type="time"
            [(ngModel)]="hora"
            class="form-control"
            [ngClass]="{ 'is-invalid': erro && !hora }"
          />
        </div>
      </div>

      <label for="descricao">DESCREVA A TAREFA</label>
      <textarea
        id="descricao"
        [(ngModel)]="description"
        class="form-control"
        placeholder="Descreva a tarefa aqui..."
      ></textarea>

      <div *ngIf="erro" class="campo-obrigatorio-msg">Preencha todos os campos obrigatórios.</div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary btn-cancelar" (click)="fechar.emit()">Cancelar</button>
      <button class="btn btn-primary btn-criar" (click)="criar()" [disabled]="carregando">
        <span *ngIf="!carregando">
          {{ contatos.length > 1 ? 'Criar ' + contatos.length + ' tarefas' : 'Criar tarefa' }}
        </span>
        <span *ngIf="carregando">Aguarde...</span>
      </button>
    </div>
  </div>
</div>